import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { userEmailValidator } from '#validation';
import { base64Validator, numberValidator, } from '#validation/common/validators';
import { CLIENT_PROOF_BASE64_LENGTH, FULL_NONCE_BASE64_MAX_LENGTH, FULL_NONCE_BASE64_MIN_LENGTH, NONCE_BASE64_MAX_LENGTH, NONCE_BASE64_MIN_LENGTH, SALT_BASE64_MAX_LENGTH, SALT_BASE64_MIN_LENGTH, STORED_KEY_BASE64_LENGTH, } from '#validation/user/constants';
export const scramStoredDataSchema = z.object({
    scramIterations: numberValidator({
        requiredError: 'user.userIdentity.scramIterations.required',
    }),
    scramSalt: base64Validator({
        requiredError: 'user.userIdentity.scramSalt.required',
        minLength: {
            min: SALT_BASE64_MIN_LENGTH,
            error: 'user.userIdentity.scramSalt.minLength',
        },
        maxLength: {
            max: SALT_BASE64_MAX_LENGTH,
            error: 'user.userIdentity.scramSalt.maxLength',
        },
        invalidFormatError: 'user.userIdentity.scramSalt.base64',
    }),
    scramStoredKey: base64Validator({
        requiredError: 'user.userIdentity.scramStoredKey.required',
        length: {
            len: STORED_KEY_BASE64_LENGTH,
            error: 'user.userIdentity.scramStoredKey.length',
        },
        invalidFormatError: 'user.userIdentity.scramStoredKey.base64',
    }),
});
const scramClientNonceValidator = base64Validator({
    requiredError: 'user.clientNonce.required',
    minLength: {
        min: NONCE_BASE64_MIN_LENGTH,
        error: 'user.clientNonce.minLength',
    },
    maxLength: {
        max: NONCE_BASE64_MAX_LENGTH,
        error: 'user.clientNonce.maxLength',
    },
    invalidFormatError: 'user.clientNonce.base64',
});
const scramClientFirstSchema = z.object({
    email: userEmailValidator,
    clientNonce: scramClientNonceValidator,
});
export class ScramClientFirstDto extends createZodDto(scramClientFirstSchema) {
}
const scramServerFirstSchema = z.object({
    iterations: z.number(),
    salt: z.string(),
    fullNonce: z.string(),
});
export class ScramServerFirstDto extends createZodDto(scramServerFirstSchema) {
}
const scramFullNonceValidator = base64Validator({
    requiredError: 'user.fullNonce.required',
    minLength: {
        min: FULL_NONCE_BASE64_MIN_LENGTH,
        error: 'user.fullNonce.minLength',
    },
    maxLength: {
        max: FULL_NONCE_BASE64_MAX_LENGTH,
        error: 'user.fullNonce.maxLength',
    },
    invalidFormatError: 'user.fullNonce.base64',
});
export const scramClientFinalSchema = z.object({
    fullNonce: scramFullNonceValidator,
    proof: base64Validator({
        requiredError: 'user.proof.required',
        length: {
            len: CLIENT_PROOF_BASE64_LENGTH,
            error: 'user.proof.length',
        },
        invalidFormatError: 'user.proof.base64',
    }),
});
export class ScramClientFinalDto extends createZodDto(scramClientFinalSchema) {
}
